export default __webpack_public_path__ + "static/media/prostate-exam.37431957.svg";